<template>
  <router-view />
</template>

<script>
export default {
  name: 'Services'
}
</script>